export default {
  setStatus(state, status) {
    state.status = status;
  },
  markAccepted(state) {
    if (state.status) {
      state.status = { ...state.status, accepted: true };
    }
  }
};
